import * as React from 'react';
import { isEmptyObject } from 'jquery';
import { I18NString, tr, goToAnchor } from '../Utils';
import { isUndefined } from 'lodash';
import Form from './Form';
import { ISectionSchema } from '../Section';
import {
  ControlErrorListItem,
  createControl,
  IControlError,
  IControlSchema,
} from '../Controls';
import { ControlValueDispatcher } from '../controls/extensions/Dispatcher';
import { Dictionary } from '../../types/Dictionary';

interface Props {
  section: ISectionSchema;
  dispatcher: ControlValueDispatcher;
  disableNumber: boolean;
  countToSend: number;
  readonly: boolean;
  values: any;
  status: number;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>;
  allVisited: boolean;
  firstErrorId: string;
  noTitle?: boolean;
  initData?: any;
}

interface State {
  scrolledSectionId?: string;
}

class Content extends React.Component<Props, State> {
  private tr: (message: I18NString) => string = tr;

  public constructor(props) {
    super(props);
    this.state = {
      scrolledSectionId: null,
    };
  }

  componentDidUpdate() {}

  shouldComponentUpdate(nextProps: Props) {
    return true;
  }

  render() {
    const { section, dispatcher, noTitle, initData } = this.props;
    let { values } = this.props;
    if (!values) values = [];

    if (!isEmptyObject(section)) {
      let controls: Array<React.ReactElement<any>> = [];

      for (let ctrl of section.controls) {
        ctrl.disableNumber = this.props.disableNumber;
        if (this.props.readonly) {
          ctrl.disabled = true;
        }

        if (ctrl.extra && ctrl.extra.init && initData[ctrl.extra.init]) {
          if (values.findIndex((value) => value.controlid === ctrl.id) > -1) {
            values[values.findIndex((value) => value.controlid === ctrl.id)] = {
              controlid: ctrl.id,
              value: initData[ctrl.extra.init],
            };
          } else {
            values.push({
              controlid: ctrl.id,
              value: initData[ctrl.extra.init],
            });
          }
        }

        if (ctrl.extra && ctrl.extra.options) {
          if (
            typeof ctrl.extra.options === 'string' &&
            typeof this.props.initData[ctrl.extra.options] !== 'undefined'
          ) {
            ctrl.options = this.props.initData[ctrl.extra.options] || [];
          } else if (
            typeof ctrl.extra.options.option !== 'undefined' &&
            typeof this.props.initData[ctrl.extra.options.source] !==
              'undefined' &&
            typeof this.props.initData[ctrl.extra.options.source] !==
              'undefined' &&
            this.props.initData[ctrl.extra.options.source]
          ) {
            ctrl.options =
              this.props.initData[ctrl.extra.options.source].map((item) => ({
                ...item,
                key: item[ctrl.extra.options.option],
                value: { ru: item[ctrl.extra.options.option] },
              })) || [];
          } else {
            ctrl.options = [];
          }
        }

        let visible = false;
        if (
          ctrl['visible'] === true ||
          typeof ctrl['visible'] === 'undefined'
        ) {
          visible = true;
        } else if (ctrl['visible'] && ctrl['visible'].length > 0) {
          let k = ctrl.visible.length;
          while (k--) {
            const linkedValue = values.filter(
              (value) =>
                String(value.controlid) === String(ctrl.visible[k].field),
            );
            if (
              linkedValue &&
              linkedValue.length === 1 &&
              ctrl.visible[k].rule === 'has_value' &&
              ctrl.visible[k].values
                .map((value) => String(value))
                .indexOf(String(linkedValue[0].value.label)) > -1
            ) {
              visible = true;
            }
          }
        }

        if (visible) {
          const element = createControl(
            ctrl,
            dispatcher,
            this.props.errors,
            values,
            this.props.visited,
            this.props.allVisited,
          );
          const key = `Content.${section.id}.${ctrl.id}`;
          controls.push(React.cloneElement(element, { key }));

          let bottom_line_classname = 'line';
          if (
            !isUndefined(ctrl['extra']) &&
            !isUndefined(ctrl['extra']['bottom-line-margin'])
          ) {
            switch (ctrl['extra']['bottom-line-margin']) {
              case 'default': {
                bottom_line_classname = 'line';
                break;
              }
              case 'large': {
                bottom_line_classname = 'line large';
                break;
              }
              case 'medium': {
                bottom_line_classname = 'line medium';
                break;
              }
              case 'small': {
                bottom_line_classname = 'line small';
                break;
              }
              case 'min': {
                bottom_line_classname = 'line min';
                break;
              }
            }
          }

          if (isUndefined(ctrl['visible'])) {
            controls.push(
              <div key={`${key}.line`} className={bottom_line_classname}></div>,
            );
          } else {
            controls.push(
              <div key={`${key}.line`} className={bottom_line_classname}></div>,
            );
          }
        }
      }

      return (
        <div className="reportbox-content">
          {section.title && !noTitle && <h4>{this.tr(section.title)}</h4>}
          <div className="line"></div>
          <Form>{controls}</Form>
        </div>
      );
    }

    return <div></div>;
  }
}

export default Content;
